import { Placemark } from "@pbe/react-yandex-maps";
import { useData } from "../../../shared/hooks/use-data"
import { TData } from "../../../shared/types/data"
import { useCallback, useMemo, useState } from "react";
import { useTheme } from "styled-components";

const getBaseFontSize = () => {
    const fontSizeString = window.getComputedStyle(document.documentElement).fontSize;

    return parseFloat(fontSizeString);
};

const getIconWithColor = (color: string, isHovered: boolean = false): string => {
    const baseFontSize = getBaseFontSize();
    const ratio = baseFontSize / 15;

    const size = 40 * ratio;
    const maxRadius = 17 * ratio;
    const radius = (isHovered ? 17 : 15) * ratio;

    const center = size / 2;

    const svg = `
        <svg height="${size}" width="${size}" xmlns="http://www.w3.org/2000/svg">
            <circle r="${radius}" cx="${maxRadius}" cy="${(maxRadius)}" fill="${color}"/>
        </svg>
    `;

    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

const CustomPlacemark = ({ item }: { item: TData }) => {
    const { selectedDataItem, setSelectedDataItem } = useData();

    const { colors } = useTheme();

    const [isHovered, setIsHovered] = useState(false);

    const iconColor = useMemo(() => {
        const { dangerLight, primary } = colors;
        return item.id === selectedDataItem?.id ? dangerLight : primary;
    }, [selectedDataItem, item]);

    const onPlacemarkClick = useCallback((e: MouseEvent): void => {
        e.stopPropagation();
        e.preventDefault();

        setSelectedDataItem(item);
    }, []);

    const geometry = useMemo(() => {
        return [item.lat, item.lon]
    }, [item]);

    const properties = useMemo(() => {
        return { item: item }
    }, [item]);

    const options = useMemo(() => {
        return {
            iconLayout: 'default#image',
            iconImageHref: getIconWithColor(iconColor, isHovered),
            iconImageSize: [24, 24],
            iconImageOffset: [-16, -16],
            zIndex: item.id === selectedDataItem?.id ? 500 : 0,
            zIndexHover: 1100,
        }
    }, [iconColor, isHovered]);

    return (
        <Placemark
            geometry={geometry}
            properties={properties}
            options={options}
            onClick={onPlacemarkClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        />
    )
}

export default CustomPlacemark;